import { render, staticRenderFns } from "./OrderPayments.vue?vue&type=template&id=fc0768da&"
import script from "./OrderPayments.vue?vue&type=script&lang=js&"
export * from "./OrderPayments.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports